import i18next from "i18next";

export enum CuoTireTypes {
  Personal = 1,
  Truck = 2,
  SpecialSolid = 3,
  Motorcycle = 4,
  SlowMoving = 5,
  SpecialPneumatic = 6
}

const CuoTireTypeLabelKeys = {
  [CuoTireTypes.Personal]: "orders.tireTypes.personal",
  [CuoTireTypes.Truck]: "orders.tireTypes.truck",
  [CuoTireTypes.SpecialSolid]: "orders.tireTypes.specialSolid",
  [CuoTireTypes.SpecialPneumatic]: "orders.tireTypes.specialPneumatic",
  [CuoTireTypes.Motorcycle]: "orders.tireTypes.motorcycle",
  [CuoTireTypes.SlowMoving]: "orders.tireTypes.slowMoving"
};

// Labels are translated on each call so they follow the current language
export const getCuoTireTypeLabel = (tireType: CuoTireTypes | null): string => {
  return tireType !== null ? i18next.t(CuoTireTypeLabelKeys[tireType], { ns: "admin" }) as string : "";
};

// Tire type names sent by the API / CUO in Polish (Sodo.Core.Domain.Const.CuoTireTypes)
const CuoTireTypeNameKeys: { [name: string]: string } = {
  "Osobowe": "orders.tireTypes.personal",
  "Ciężarowe": "orders.tireTypes.truck",
  "Motocyklowe": "orders.tireTypes.motorcycle",
  "Wolnobieżna": "orders.tireTypes.slowMovingCuo",
  "Wolnobieżne": "orders.tireTypes.slowMoving",
  "Specjalne - pełne": "orders.tireTypes.specialSolid",
  "Specjalne - pneumatyczne": "orders.tireTypes.specialPneumatic",
};

// Translates a Polish tire type name for display; unknown names are returned as they are
export const translateCuoTireTypeName = (name: string): string =>
  CuoTireTypeNameKeys[name] !== undefined ? i18next.t(CuoTireTypeNameKeys[name], { ns: "admin" }) as string : name;

export const getCuoTireTypeOptions = () => [
  CuoTireTypes.Personal,
  CuoTireTypes.Truck,
  CuoTireTypes.SpecialSolid,
  CuoTireTypes.SpecialPneumatic,
  CuoTireTypes.Motorcycle,
  CuoTireTypes.SlowMoving
].map((tireType) => ({ key: tireType, text: getCuoTireTypeLabel(tireType) }));
